import { CatalogueSearchModel } from '../../models/catalogue/catalogueSearch';
import * as CatalogueModels from '../../models/catalogue/catalogue';

export class GetCatalogueList {
  static readonly type = 'GetCatalogueList';
  constructor(public Search: CatalogueSearchModel) { }
}

export class GetCatalogue {
  static readonly type = '[Catalogue] GetCatalogue';
  constructor(public CatalogueId: number) { }
}

export class Refresh {
  static readonly type = '[Catalogue] Refresh';
  constructor(public Catalogue: CatalogueModels.CatalogueModel) { }
}

export class SetCatalogue {
  static readonly type = '[Catalogue] SetCatalogue';
  constructor(public Catalogue: CatalogueModels.CatalogueModel) { }
}

export class SetCatalogueSearch {
  static readonly type = '[Catalogue] SetCatalogueSearch';
  constructor(public Search: CatalogueSearchModel) { }
}

export class ResetCatalogueSearch {
  static readonly type = '[Catalogue] ResetCatalogueSearch';
  constructor() { }
}

export class SetCatalogueListPage {
  static readonly type = '[Catalogue] SetCatalogueListPage';
  constructor(public Search: CatalogueSearchModel) { }
}

export class DeleteCatalogueItem {
  static readonly type = '[Catalogue] DeleteCatalogueItem';
  constructor(public TyreId: number) { }
}

export class Insert {
  static readonly type = '[Catalogue] Insert';
  constructor(public Tyre: CatalogueModels.NewTyreModel) { }
}

export class Set {
  static readonly type = '[Catalogue] Set';
  constructor(public Tyre: CatalogueModels.NewTyreModel) { }
}

export class DisposeSearch {
  static readonly type = '[Catalogue] DisposeSearch';
  constructor() { }
}
